import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DashboardSidebarService {
  private static STORAGE_KEY = 'dashboard_sidebar_collapsed';

  // Desktop collapsed state (true = mini sidebar, false = full width)
  private _desktopCollapsed = new BehaviorSubject<boolean>(
    this.getInitialCollapsedState()
  );
  readonly desktopCollapsed$ = this._desktopCollapsed.asObservable();

  // Mobile drawer open state
  private _mobileOpen = new BehaviorSubject<boolean>(false);
  readonly mobileOpen$ = this._mobileOpen.asObservable();

  // Backward compatibility alias for mobile drawer open
  readonly sidebarOpen$ = this.mobileOpen$;

  private getInitialCollapsedState(): boolean {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        return localStorage.getItem(DashboardSidebarService.STORAGE_KEY) === 'true';
      }
    } catch {
      // Fallback if localStorage is unavailable
    }
    return false;
  }

  toggleDesktopCollapsed(): void {
    const nextState = !this._desktopCollapsed.value;
    this._desktopCollapsed.next(nextState);
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(DashboardSidebarService.STORAGE_KEY, String(nextState));
      }
    } catch {
      // Ignore storage errors
    }
  }

  setDesktopCollapsed(collapsed: boolean): void {
    this._desktopCollapsed.next(collapsed);
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        localStorage.setItem(DashboardSidebarService.STORAGE_KEY, String(collapsed));
      }
    } catch {
      // Ignore storage errors
    }
  }

  toggleMobile(): void {
    this._mobileOpen.next(!this._mobileOpen.value);
  }

  openMobile(): void {
    this._mobileOpen.next(true);
  }

  closeMobile(): void {
    this._mobileOpen.next(false);
  }

  // Legacy toggle method delegates to toggleMobile on mobile or toggleDesktopCollapsed on desktop
  toggle(): void {
    this.toggleMobile();
  }

  close(): void {
    this.closeMobile();
  }
}

